import Http from '../Http';

export class SucursalService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`sucursal/filter?${params.toString()}`);
      return res.data.rows || res.data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`sucursal/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`sucursal/one/${id}`);
      return res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async obtenerOpcionesForm(params: Record<string, any> = {}) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        searchParams.set(k, String(v));
      }
    });
    try {
      const queryStr = searchParams.toString();
      const url = queryStr ? `sucursal/form?${queryStr}` : `sucursal/form`;
      const res = await Http.get(url);
      return res.data;
    } catch (e) {
      console.error(e);
      return {};
    }
  }

  static async guardar(data: Record<string, any>) {
    try {
      const res = await Http.post('sucursal/save', data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al guardar la sucursal' };
    }
  }

  static async obtenerEncargados(id: string | number) {
    try {
      const res = await Http.get(`sucursal/${id}/encargados`);
      return res.data && res.data.encargados ? res.data.encargados : [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async guardarEncargados(id: string | number, encargados: any[]) {
    try {
      const res = await Http.post(`sucursal/${id}/encargados/save`, { encargados });
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al guardar encargados' };
    }
  }

  static async eliminarEncargado(id: string | number) {
    try {
      const res = await Http.post('sucursal/encargado/delete', { id });
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al eliminar encargado' };
    }
  }
}
